export default (src, { width = 0, height = 0 } = {}, options = 'scalemode=centered&quality=60') => {
  return `${src.replace('0x0', `${width}x${height}`)}?${options}`;
}
